export const phones = [
  { display: '+1 954 795 41 98', href: 'tel:+19547954198' },
  { display: '+1 754 276 24 67', href: 'tel:+17542762467' },
]

export const email = 'Byronmontoya@standardconsultingadvice.com'

export const whatsappUrl = 'https://wa.me/19547954198'

export const website = {
  display: 'standardconsultingadvice.com',
  href: 'https://standardconsultingadvice.com',
}
